import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { Actions } from '../actions/userConsent';
import { ITosConsent } from '../interfaces/userConsent';

export type State = DeepReadonly<{
  isFetchingTos: boolean;
  isFetchingEula: boolean;
  isUpdating: boolean;
  tosConsent: ITosConsent | null;
  forceShowTos: boolean;
  eulaConsent: boolean | null;
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetchingTos: false,
  isFetchingEula: false,
  isUpdating: false,
  tosConsent: null,
  forceShowTos: false,
  eulaConsent: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_TOS_CONSENT_REQUEST':
      return {
        ...state,
        isFetchingTos: true
      };
    case 'FETCH_TOS_CONSENT_SUCCESS':
      return {
        ...state,
        isFetchingTos: false,
        tosConsent: action.payload,
        forceShowTos: false,
        error: null
      };
    case 'FETCH_TOS_CONSENT_FAILURE':
      return {
        ...state,
        isFetchingTos: false,
        error: action.error
      };
    case 'UPDATE_TOS_CONSENT_REQUEST':
      return {
        ...state,
        isUpdating: true
      };
    case 'UPDATE_TOS_CONSENT_SUCCESS':
      return {
        ...state,
        isUpdating: false,
        error: null
      };
    case 'UPDATE_TOS_CONSENT_FAILURE':
      return {
        ...state,
        isUpdating: false,
        error: action.error
      };
    case 'FORCE_SHOW_TOS_CONSENT':
      return {
        ...state,
        isFetchingTos: false,
        forceShowTos: true
      };
    case 'FETCH_EULA_CONSENT_REQUEST':
      return {
        ...state,
        isFetchingEula: true
      };
    case 'FETCH_EULA_CONSENT_SUCCESS':
      return {
        ...state,
        isFetchingEula: false,
        eulaConsent: action.payload,
        error: null
      };
    case 'FETCH_EULA_CONSENT_FAILURE':
      return {
        ...state,
        isFetchingEula: false,
        error: action.error
      };
    default:
      return state;
  }
}
